var map = {
	"./modules/common/associates/associate-type.module": [
		"./mds-ui/app/modules/common/associates/associate-type.module.ts",
		"default~modules-common-associates-associate-type-module~modules-common-master-data-setup-master-data~827a0900",
		"default~modules-common-associates-associate-type-module~modules-common-master-data-setup-master-data~f12f2b11",
		"default~modules-common-associates-associate-type-module~modules-common-master-data-setup-master-data~d06c72a9"
	],
	"./modules/common/master-data-setup/master-data-setup.module": [
		"./mds-ui/app/modules/common/master-data-setup/master-data-setup.module.ts",
		"default~modules-common-associates-associate-type-module~modules-common-master-data-setup-master-data~827a0900",
		"default~modules-common-associates-associate-type-module~modules-common-master-data-setup-master-data~f12f2b11",
		"default~modules-common-associates-associate-type-module~modules-common-master-data-setup-master-data~d06c72a9",
		"common",
		"modules-common-master-data-setup-master-data-setup-module"
	],
	"./modules/common/reports/reports.module": [
		"./mds-ui/app/modules/common/reports/reports.module.ts",
		"modules-common-reports-reports-module"
	],
	"./modules/common/settings/settings.module": [
		"./mds-ui/app/modules/common/settings/settings.module.ts",
		"modules-common-settings-settings-module"
	],
	"./modules/consecrated/master-data-setup/master-data-setup.module": [
		"./mds-ui/app/modules/consecrated/master-data-setup/master-data-setup.module.ts",
		"default~modules-common-associates-associate-type-module~modules-common-master-data-setup-master-data~827a0900",
		"modules-consecrated-master-data-setup-master-data-setup-module"
	],
	"./modules/deacon/deacon.module": [
		"./mds-ui/app/modules/deacon/deacon.module.ts",
		"common",
		"modules-deacon-deacon-module"
	],
	"./modules/fingerprint/fingerprint-summary/fingerprint-type.module": [
		"./mds-ui/app/modules/fingerprint/fingerprint-summary/fingerprint-type.module.ts",
		"default~modules-common-associates-associate-type-module~modules-common-master-data-setup-master-data~827a0900",
		"modules-fingerprint-fingerprint-summary-fingerprint-type-module"
	],
	"./modules/hr/humanresource.module": [
		"./mds-ui/app/modules/hr/humanresource.module.ts",
		"default~modules-common-associates-associate-type-module~modules-common-master-data-setup-master-data~827a0900",
		"modules-hr-humanresource-module"
	],
	"./modules/priest/priest.module": [
		"./mds-ui/app/modules/priest/priest.module.ts",
		"default~modules-common-associates-associate-type-module~modules-common-master-data-setup-master-data~827a0900",
		"common",
		"modules-priest-priest-module"
	],
	"./modules/psms/psms.module": [
		"./mds-ui/app/modules/psms/psms.module.ts",
		"default~modules-common-associates-associate-type-module~modules-common-master-data-setup-master-data~827a0900",
		"default~modules-common-associates-associate-type-module~modules-common-master-data-setup-master-data~f12f2b11",
		"default~modules-common-associates-associate-type-module~modules-common-master-data-setup-master-data~d06c72a9",
		"common",
		"modules-psms-psms-module"
	],
	"./modules/seminarian/seminarian.module": [
		"./mds-ui/app/modules/seminarian/seminarian.module.ts",
		"default~modules-common-associates-associate-type-module~modules-common-master-data-setup-master-data~827a0900",
		"common",
		"modules-seminarian-seminarian-module"
	],
	"./modules/studentipm/studentipm.module": [
		"./mds-ui/app/modules/studentipm/studentipm.module.ts",
		"default~modules-common-associates-associate-type-module~modules-common-master-data-setup-master-data~827a0900",
		"modules-studentipm-studentipm-module"
	],
	"./modules/users/admin-profile/admin-profile.module": [
		"./mds-ui/app/modules/users/admin-profile/admin-profile.module.ts",
		"common",
		"modules-users-admin-profile-admin-profile-module"
	],
	"./modules/users/admin-roles/admin-roles.module": [
		"./mds-ui/app/modules/users/admin-roles/admin-roles.module.ts",
		"modules-users-admin-roles-admin-roles-module"
	],
	"./modules/users/admin-users/admin-users.module": [
		"./mds-ui/app/modules/users/admin-users/admin-users.module.ts",
		"common",
		"modules-users-admin-users-admin-users-module"
	],
	"./modules/users/psms-users/psms-users.module": [
		"./mds-ui/app/modules/users/psms-users/psms-users.module.ts",
		"default~modules-common-associates-associate-type-module~modules-common-master-data-setup-master-data~827a0900",
		"default~modules-common-associates-associate-type-module~modules-common-master-data-setup-master-data~f12f2b11",
		"common",
		"modules-users-psms-users-psms-users-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;